import { render, staticRenderFns } from "./RelatorioPerfilTurma.vue?vue&type=template&id=d698596a&"
import script from "./RelatorioPerfilTurma.vue?vue&type=script&lang=js&"
export * from "./RelatorioPerfilTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports